module.exports = __webpack_public_path__ + "img/stock2.a5e08ac6.png";